import classNames from "classnames";
import type { ButtonProps } from "@mui/material";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { CopyIcon } from "../../../../shared/icons/CopyIcon";
import styles from "./styles.module.css";
import { TCopyFormat } from "./types";
import { handleCopyToClipboard } from "./utils/handleCopyToClipboard";

type ButtonPosition = "absolute" | "static";

interface Props extends ButtonProps {
  copyObjectRef?: React.RefObject<HTMLDivElement>;
  copyFormat?: TCopyFormat;
  copyContent?: string;
  position?: ButtonPosition;
  className?: string;
}

export const CopyButton = ({
  copyObjectRef,
  copyFormat,
  copyContent,
  position,
  className,
  ...props
}: Props) => {
  const cls = classNames(
    styles["copy-button"],
    {
      [styles.absolute]: position === "absolute",
      [styles.relative]: position === "static",
    },
    className,
  );

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (copyContent) {
      navigator.clipboard.writeText(copyContent);
    } else if (copyObjectRef && copyFormat) {
      handleCopyToClipboard(copyObjectRef, copyFormat);
    }
  };

  return (
    <AppIconButton
      onClick={handleCopy}
      disableRipple
      className={cls}
      {...props}
    >
      <CopyIcon />
    </AppIconButton>
  );
};
